<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="">
      <el-select class="select_btn_style" v-model="filters.myAuditStatus" placeholder="我的审核状态">
        <el-option v-for="(item, i) in auditStatusAttr" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item class=" m-l-14">
      <el-select class="select_btn_style" v-model="filters.finalAuditStatus" placeholder="最终审核状态">
        <el-option v-for="(item, i) in auditStatusAttr" :key="i" :label="item.paramValue"
          :value="item.paramKey"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input prefix-icon="el-icon-search" clearable v-model="filters.name" placeholder="姓名/手机号码"></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import { getDataMap } from "@/api/sysParam";
import butn from "@/components/button/index";

export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      auditStatusAttr: [],
    };
  },
  created() {
    this.getSysParam();
  },
  methods: {
    // 获取数据字典
    getSysParam() {
      getDataMap("USER_MODIFY_AUDIT_STATUS").then((res) => {
        if (res.code !== 0) return;
        res.data.splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.auditStatusAttr = res.data;
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.initData();
    },
  },
};
</script>
<style lang="scss" scoped>
.select_btn_style {
  width: 150px;
}
</style>
